<template>
	<el-menu
		:default-active.sync="activeLink"
		:default-openeds="defaultOpenedMenus"
		:mode="mode"
		@select="goto"
		:collapse="isCollapse"
		:unique-opened="true"
		background-color="transparent"
		class="main-navigation-menu"
		:class="{'nav-collapsed':isCollapse}"
	>

		<el-menu-item index="/dashboard">
			<i class="mdi mdi-gauge"></i><span slot="title">{{ $t("left-menu.tableau-de-bord") }}</span>
		</el-menu-item>
		<!-- <div v-if="$can('read', 'ERP Report')"> -->
		<el-menu-item index="/customers/invoices" v-if="$can('read', 'CustomerInvoices') && !$can('manage','all')">
			<i class="mdi mdi-file-document"></i><span slot="title">{{ $t("left-menu.my_invoices") }}</span>
		</el-menu-item>
		<!-- <el-menu-item index="/customers/sales_order" v-if="($can('read', 'CustomerInvoices') || $can('read', 'CustomerPayments')) && !$can('manage','all')">
			<i class="el-icon-s-order"></i><span slot="title">{{ $t("left-menu.my_sales_orders") }}</span>
		</el-menu-item> -->
		<!-- <el-menu-item index="/calendar">
			<i class="mdi mdi-calendar"></i><span slot="title">{{ $t("left-menu.calendrier") }}</span>
		</el-menu-item> -->


		<div class="el-menu-item-group__title" v-if="$can('read', 'Customer') || $can('read', 'Contacts') || $can('read', 'Invoices')"><span>CRM</span></div>
		<el-submenu index="crm-customers" popper-class="main-navigation-submenu" v-if="$can('read', 'Customer')">
			<template slot="title">
				<i class="mdi mdi-account-multiple"></i><span>{{ $t("left-menu.clients") }}</span>
			</template>
			<el-menu-item index="/customers">
				<span slot="title">{{ $t("left-menu.customersList") }}</span>
			</el-menu-item>
			<el-menu-item index="/contacts" v-if="$can('read', 'Contacts')">
				<span slot="title">{{ $t("left-menu.contacts") }}</span>
			</el-menu-item>
			<el-menu-item index="/visits">
				<span slot="title">{{ $t("left-menu.visits") }}</span>
			</el-menu-item>
		</el-submenu>
		<el-menu-item index="/invoices" v-if="$can('read', 'Invoices') && isInvoicingModuleactive === true">
			<i class="mdi mdi-file-document"></i><span slot="title">{{ $t("left-menu.invoices") }}</span>
		</el-menu-item>
		<el-menu-item index="/sales-orders" v-if="$can('read', 'SalesOrders')">
			<i class="el-icon-s-order"></i><span slot="title">{{ $t("left-menu.sales-orders") }}</span>
		</el-menu-item>
		<el-menu-item index="/reservations" v-if="$can('read', 'SalesOrders') && isReservationModuleActive">
			<i class="mdi mdi-bookmark-check"></i><span slot="title">{{ $t("left-menu.reservations") }}</span>
		</el-menu-item>

		<el-submenu index="return" popper-class="main-navigation-submenu" v-if="($can('read', 'SalesOrders') || $can('read', 'Invoices')) && isInvoicingModuleactive === true">
			<template slot="title">
				<i class="mdi mdi-keyboard-return"></i><span>{{ $t("left-menu.returns") }}</span>
			</template>
			<el-menu-item index="/sales-returns" :disabled="true">
				<span slot="title">{{ $t("left-menu.salesReturns") }}</span>
			</el-menu-item>
			<el-menu-item index="/credit-notes">
				<span slot="title">{{ $t("left-menu.creditNotes") }}</span>
			</el-menu-item>
		</el-submenu>


		<div class="el-menu-item-group__title" v-if="$can('read', 'Inventories')"><span>Inventaires</span></div>
		<el-submenu :index="'inventories'+i.id" popper-class="main-navigation-submenu" v-for="i in inventories" :key="i.id" v-if="$can('read', 'Inventories') && i.active === true">
			<template slot="title">
				<i class="mdi mdi-view-quilt"></i><span>{{i.name}}</span>
			</template>
			<el-menu-item :index="'/inventories/'+i.id+'/items'">
				<span slot="title">{{$t('common.products')}}</span>
			</el-menu-item>
			<el-menu-item v-if="i.code !== 'SAQ_AUTO'" :index="'/inventories/'+i.id+'/purchase-orders'">
				<span slot="title">{{$t('left-menu.purchaseOrders')}}</span>
			</el-menu-item>
		</el-submenu>


		<div class="el-menu-item-group__title" v-if="canAccessConfiguration"><span>{{$t('left-menu.system')}}</span></div>
      <el-menu-item index="/settings" v-if="canAccessConfiguration">
        <i class="el-icon-setting"></i><span slot="title">{{$t('left-menu.settings')}}</span>
      </el-menu-item>
		<el-menu-item index="/reports" v-if="$can('read', 'Reports') || $can('read', 'SalesReports')">
			<i class="mdi mdi-chart-bar"></i><span slot="title">{{ $t("left-menu.reports") }}</span>
		</el-menu-item>

		<!-- <el-submenu index="cms" popper-class="main-navigation-submenu" v-if="isCMSModuleActivated && ($can('manage','CMS') || $can('manage','all'))">
			<template slot="title">
				<i class="el-icon-s-platform"></i><span>CMS</span>
			</template>
			<el-menu-item index="/CMS/settings" v-if="$can('read', 'CMS')">
				<i class="el-icon-s-tools"></i><span slot="title">{{ $t("left-menu.CMSSettings") }}</span>
			</el-menu-item>
			<el-menu-item index="/CMS/galleries" v-if="$can('read', 'CMS')">
				<i class="el-icon-picture"></i><span slot="title">{{ $t("left-menu.galleries") }}</span>
			</el-menu-item>
			<el-menu-item index="/CMS/providers" v-if="$can('read', 'CMS')">
				<i class="el-icon-office-building"></i><span slot="title">{{ $t("left-menu.providers") }}</span>
			</el-menu-item>
			<el-menu-item index="/CMS/products" v-if="$can('read', 'CMS')">
				<i class="el-icon-s-goods"></i><span slot="title">{{ $t("left-menu.products") }}</span>
			</el-menu-item>
			<el-menu-item index="/CMS/articles" v-if="$can('read', 'CMS')">
				<i class="el-icon-document-copy"></i><span slot="title">{{ $t("left-menu.articles") }}</span>
			</el-menu-item>
	</el-submenu> -->


	</el-menu>
</template>


<script>
import { detect } from 'detect-browser'
import InventoryAPI from '@/services/API/inventory'
import { mapActions, mapState, mapGetters } from 'vuex';

const browser = detect()

export default {
	name: 'Nav',
	props: ['mode', 'isCollapse'],
	data() {
		return {
			isIe: true,
			isEdge: true,
			activeLink: null,
			defaultOpenedMenus: ['crm-customers']
		}
	},
	methods: {
		goto(index, indexPath) {
			if(index.charAt(0) === '/') {
				this.$router.push(index)
				this.$emit('push-page', {page:index})
			}

		},
		setLink(path) {
			this.activeLink = path
		},
		...mapActions('inventory',['fetchInventories']),
		...mapActions('controlData',['fetchCMSConfiguration'])
	},
	computed : {
    canAccessConfiguration () {
      return  this.$can('manage', 'all') ||
                // this.$can('read', 'Reports') ||
      //        this.$can('read', 'SalesReports') ||
      //        this.$can('read', 'PaymentsReports') ||
      //        this.$can('manage','CMS') ||
             this.$can('manage', 'CRM config');
    },
		...mapGetters('reservations',['isReservationModuleActive']),
		...mapState('inventory',['inventories']),
		...mapGetters('controlData',['isCMSModuleActivated']),
		...mapGetters(['isInvoicingModuleactive'])
	},
  mounted(){

  },
	created() {
		if(browser.name !== 'ie') this.isIe = false
		if(browser.name !== 'edge') this.isEdge = false

    if(this.$store.isAnonymousAuth == false){
			this.fetchInventories();
      this.fetchCMSConfiguration();
		}

		this.setLink(this.$router.currentRoute.path)
		this.$router.afterEach((to, from) => {
			this.setLink(this.$router.currentRoute.path)
			//console.log('afterEach', to, from)
		})
		//console.log('this.$router.currentRoute.path', this.$router.currentRoute.path)
	}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables';

.el-menu {
	border: none;
}
.el-menu::before, .el-menu::after {
	display: none;
}
.el-submenu, .el-menu-item {
	.mdi {
		vertical-align: middle;
		margin-right: 5px;
		display: inline-block;
		width: 24px;
		text-align: center;
		font-size: 18px;
	}
}
</style>

<style lang="scss">
@import '../assets/scss/_variables';

.main-navigation-menu {
	transition: width .5s;

	&:not(.el-menu--collapse) {
		.el-submenu__title, .el-menu-item {
			height: 40px;
			line-height: 40px;
			background-color: transparent !important;
		}

		&:not(.el-menu--horizontal) {
			.el-menu-item, .el-submenu {
				position: relative;

				&::before {
					content: '';
					display: block;
					width: 0px;
					height: 1px;
					position: absolute;
					bottom: 10px;
					left: 30px;
					background: $text-color;
					z-index: 1;
					opacity: 0;
					transition: all .7s cubic-bezier(.55,0,.1,1);
				}
				&:hover {
					&::before {
						width: 100px;
						opacity: 1;
						//left: 50px;
						transform: translate(20px, 0);
					}
				}

				&.is-active {
					&::before {
						background: $text-color-accent;
					}
				}
			}
		}

		.el-submenu.is-opened {
			//background: #edf1f6 !important;
			//background: rgba(223, 228, 234, 0.38) !important;
			position: relative;

			&::after {
				content: '';
				display: block;
				width: 2px;
				position: absolute;
				top: 40px;
				bottom: 10px;
				left: 31px;
				background: $text-color;
				z-index: 1;
			}

			&::before {
				display: none;
			}

			.el-menu-item, .el-submenu {
				&::before, &::after {
					display: none;
				}
			}
		}

		.el-menu-item-group__title {
			padding: 15px 0 0px 20px;
			color: transparentize($text-color, 0.65);
		}
	}

	.el-submenu__title, .el-menu-item:not(.is-active) {
		color: $text-color;

		i {
			color: $text-color;
		}
	}

	&.el-menu--collapse {
		.el-menu-item-group__title {
			padding: 15px 0 0px 0px;
			width: 100%;
			text-align: center;
		}

		.el-submenu__title:hover, .el-menu-item:hover {
			background-color: rgba(0, 0, 0, 0.05) !important;
		}
	}

	&.el-menu--horizontal {
		white-space: nowrap;
		/*width: fit-content;
		width: max-content;*/
		overflow: hidden;
		display: table;

		& > * {
			float: inherit !important;
			display: inline-block;
		}
	}

	&.nav-collapsed {
		.el-menu-item,.el-submenu__title {
			& > span {
				display: none;
			}
		}
	}
}

.main-navigation-submenu {
	.el-menu {
		background: #fff !important;

		.el-menu-item:not(.is-active) {
			color: $text-color;
		}
		.el-menu-item:hover {
			background-color: transparentize($background-color, 0.3) !important;
		}
	}
}
</style>
